import { render, staticRenderFns } from "./IconLearn.vue?vue&type=template&id=5a4cfd0c"
import script from "./IconLearn.vue?vue&type=script&lang=js"
export * from "./IconLearn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports